import React from 'react';
import { connect } from 'react-redux';
import GeneralPageLayout from "../components/login/LoginPageLayout";
import { AlertNotification, Text } from '@commonsku/styles';

function UnsubscribeApp({
    message,
    error,
}: { message: string, error: boolean }) {
    return (
        <GeneralPageLayout>
            <div style={{ margin: 30 }}>
                <h3>Unsubscribed!</h3>
                <AlertNotification
                    alertType={error ? 'error' : 'success'}
                >
                    <Text as="p" color="secondary3" style={{ marginBottom: 0, fontFamily: "skufont-regular, sans-serif" }}>
                        {message}
                    </Text>
                </AlertNotification>
            </div>
        </GeneralPageLayout>
    );
}

const mapStateToProps = (state) => {
    return {
        message: state.display.message,
        error: state.display.error,
    };
};

export default connect(mapStateToProps)(UnsubscribeApp);
